export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/78489dd5fe22b2b724f99f5861a7cee7.svg";